import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import RelateNodeGraph from '../relate/RelateNodeGraph';
import RobustLineIntersector from '../../algorithm/RobustLineIntersector';
var ConsistentAreaTester = /*#__PURE__*/function () {
  function ConsistentAreaTester() {
    _classCallCheck(this, ConsistentAreaTester);
    ConsistentAreaTester.constructor_.apply(this, arguments);
  }
  _createClass(ConsistentAreaTester, [{
    key: "isNodeEdgeAreaLabelsConsistent",
    value: function isNodeEdgeAreaLabelsConsistent() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();
        if (!node.getEdges().isAreaLabelsConsistent(this._geomGraph)) {
          this._invalidPoint = node.getCoordinate().copy();
          return false;
        }
      }
      return true;
    }
  }, {
    key: "getInvalidPoint",
    value: function getInvalidPoint() {
      return this._invalidPoint;
    }
  }, {
    key: "hasDuplicateRings",
    value: function hasDuplicateRings() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();
        for (var i = node.getEdges().iterator(); i.hasNext();) {
          var eeb = i.next();
          if (eeb.getEdgeEnds().size() > 1) {
            this._invalidPoint = eeb.getEdge().getCoordinate(0);
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "isNodeConsistentArea",
    value: function isNodeConsistentArea() {
      var intersector = this._geomGraph.computeSelfNodes(this._li, true, true);
      if (intersector.hasProperIntersection()) {
        this._invalidPoint = intersector.getProperIntersectionPoint();
        return false;
      }
      this._nodeGraph.build(this._geomGraph);
      return this.isNodeEdgeAreaLabelsConsistent();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._li = new RobustLineIntersector();
      this._geomGraph = null;
      this._nodeGraph = new RelateNodeGraph();
      this._invalidPoint = null;
      var geomGraph = arguments[0];
      this._geomGraph = geomGraph;
    }
  }]);
  return ConsistentAreaTester;
}();
export { ConsistentAreaTester as default };